import * as Yup from "yup";
const SubMenuCollectionSchema = Yup.object({
 parent_id: Yup.string().nullable().default(null),
 name: Yup.string().required("Name is required"),
 url: Yup.string().default(""),
 menuType: Yup.string().oneOf(
  ["colors", "attrubutes", "Category"],
  "Invalid MenuType"
 ),
});

const ProductSchema = Yup.object({
 name: Yup.string().required("Name is required"),
 sku: Yup.string().required("Sku code  is required"),
 quantity: Yup.number()
  .moreThan(0, "Quantity must be greater than 0")
  .required("Quantity is required"),
 category_id: Yup.array()
  .of(Yup.string().required("Category is required"))
  .min(1, "At least one category must be selected"),

 sizes: Yup.array()
  .of(
   Yup.object({
    quantity: Yup.number(),
    price: Yup.number()
     .required("Price is required")
     .min(0, "Price must be greater than or equal to 0"),
   })
  )
  .test("size-id-validation", "Size data is required", function (value) {
   const { optionType } = this.parent;
   if (optionType === "Size" && (!value || value.length === 0)) {
    return false;
   }
   return true;
  }),
 weight: Yup.number()
  .required("Weight is required")
  .min(0, "Price cannot be negative"),
 retail_price: Yup.number()
  .required("Price is required")
  .min(0, "Price cannot be negative"),
 description: Yup.string().required("Description is required"),
 retail_discount: Yup.number()
  .min(0, "Discount cannot be negative")
  .max(99, "Discount must be less than 100"),
 images: Yup.array()
  .min(1, "At least one image is required")
  .max(5, "You can upload up to 5 images only"),
});

const CatlogProductSchema = Yup.object({
 productName: Yup.string().required("Product Name is required"),
 productCode: Yup.string().required("Product Code is required"),
 retailPrice: Yup.number()
  .required("Retail Price is required")
  .min(0, "Retail Price cannot be negative"),
 productDiscount: Yup.number()
  .required("Discount is required")
  .min(0, "Discount cannot be negative"),
 avgPrice: Yup.number().min(0, "Average Price cannot be negative"),
 productWeight: Yup.number()
  .min(0, "Weight cannot be negative")
  .required("Weight is required"),
});

const catlogschema = Yup.object({
 name: Yup.string().required("Name is required"),
 cat_code: Yup.string().required("code is required"),
 
 GST: Yup.number()
  .min(0, "Negative percentage is not allowde")
  .max(100, "Maximum GST percentage is 100"),
 quantity: Yup.number()
  .min(1, "Minimum 1 pices is required")
  .required("Quantity is required"),
 catalogue_discount: Yup.number()
  .min(0, "Minimum 1 quantity is required")
  .max(100, "Maximum discount percentage is 100"),
 no_of_product: Yup.number()
  .required("No of product is required")
  .min(1, "Minimum 1 product is required")
  .max(50, "Maximum 50 products are allowed"),
 price: Yup.string().required("Price is required"),
 description: Yup.string().required("Description is required"),
 tag: Yup.array()
  .of(Yup.string().required("Tag cannot be empty"))
  .min(1, "At least one tag is required"),
 average_price: Yup.string().required("Average price is required"),
 meta_title: Yup.string().required("Meta title is required"),
 meta_keyword: Yup.string().required("Meta keyword is required"),
 meta_description: Yup.string().required("meta description is required"),

 coverImage: Yup.string().required("Image is required"),
});

const StitchingOptionSchema = Yup.object().shape({
 name: Yup.string().required("Name is required"),
 category_id: Yup.string().required("Category is required"),
 optionfield: Yup.array()
  .of(
   Yup.object().shape({
    name: Yup.string().required("Name is required "),
    price: Yup.number()
     .min(0, "Price must be a positive number")
     .required("Price is required "),
    type: Yup.string().required("Type is required "),
    dispatch_time: Yup.string().optional(""),
   })
  )
  .min(1, "Stitching Group is required")
  .required("Stitching Group is required"),
});

const OrderSchema = Yup.object({
 orderstatus: Yup.string().required("Field is required"),
 Courier: Yup.string().optional(),
 tracking: Yup.string().optional(),
});

const brandSchema = Yup.object({
 name: Yup.string().required("Name is required"),
});

const currencyschema = Yup.object({
 code: Yup.string()
  .matches(/^[A-Z]{3}$/, "Code must be exactly three uppercase letters")
  .required("Code is required"),

 symbol: Yup.string().required("Symbol is required"),

 rate: Yup.number()
  .typeError("Rate must be a number")
  .positive("Rate must be a positive number")
  .required("Rate is required"),
});

const shippingRateSchema = Yup.object({
 name: Yup.string().required("Name is required"),
 type: Yup.string().required("Type is required"),
 price: Yup.number()
  .required("Price is required")
  .min(0, "Price cannot be negative"),

 maxWeight: Yup.number()
  .nullable()
  .notRequired()
  .min(0, "Weight cannot be negative")
  .max(400, "Weight must be below 400"),

 minWeight: Yup.number()
  .nullable()
  .notRequired()
  .min(0, "Weight cannot be negative")
  .max(400, "Weight must be below 400"),

 minprice: Yup.number()
  .nullable()
  .notRequired()
  .min(0, "Price cannot be negative"),

 maxprice: Yup.number()
  .nullable()
  .notRequired()
  .min(0, "Price cannot be negative"),
});

const CatlogProductSchemaApply = Yup.object({
 name: Yup.string().required("Product Name is required"),
 sku: Yup.string().required("Product Code is required"),
 weight: Yup.number()
  .min(1, "Minimum 1 weight is required")
  .required("Weigth is required"),
 quantity: Yup.number()
  .min(1, "Minimum 1 quantity is required")
  .required("Quantity is required"),
 retailPrice: Yup.number().min(0, "Retail Price cannot be negative"),
 retail_discount: Yup.number().min(0, "Discount cannot be negative"),
 average_price: Yup.number().min(0, "Average Price cannot be negative"),
 meta_title: Yup.string().required("meta_title is required"),
 meta_keyword: Yup.string().required("meta_keyword is required"),
 meta_description: Yup.string().required("meta_description is required"),

 description: Yup.string().required("Description is required"),

 images: Yup.array()
  .of(
   Yup.mixed()
    .test("fileOrPath", "Unsupported file format or invalid path", (value) => {
     if (typeof value === "string") {
      const extensionRegex = /\.(jpeg|jpg|png|webp)$/i;
      return extensionRegex.test(value);
     }
     if (value instanceof File) {
      return ["image/jpeg", "image/png", "image/webp", "image/jpg"].includes(
       value.type
      );
     }
     return false;
    })
    .required("Image is required")
  )
  .min(1, "At least one image is required")
  .max(5, "You can upload up to 5 images only"),
});

const Permissionschema = Yup.object().shape({
 role_id: Yup.string().required("Role is required"),
 page_id: Yup.object().required("Module is required"),
 actions: Yup.array()
  .min(1, "Select at least one action")
  .of(Yup.object().shape({ label: Yup.string(), value: Yup.string() })),
});

const HandlerSchema = Yup.object({
 role_id: Yup.object().required("Role is required"),
 userName: Yup.string().required("User name is required"),
 email: Yup.string().email().required("Email is required"),
});

const layoutSchema = Yup.object({
 pageName: Yup.string().required("Select a page"),
});

const shippingZoneSchema = Yup.object({
 name: Yup.string().required("Name is required"),
 countries: Yup.array()
  .min(1, "Country is required")
  .required("Country is required"),
});

const CmsContentsSchema = Yup.object({
 pageName: Yup.string().required("Page Name is required"),
 content: Yup.string().required("Content is required"),
 title: Yup.string().required("Title is required"),
});
const ImportCurrencySchema = Yup.object().shape({
 csv: Yup.mixed()
  .required("CSV file is required")
  .test("fileType", "Only CSV files are allowed", (value) => {
   if (!value) return false;
   return value.type === "text/csv";
  }),
});

const CatalogueproductValidationSchema = Yup.object().shape({
 name: Yup.string().required("Name is required"),
 sku: Yup.string().required("SKU is required"),
 quantity: Yup.string()
  .required("Quantity is required"),
 weight: Yup.string()
  .required("Weight is required"),
 images: Yup.array().min(1, "At least one image is required"),
});

const themeSchema = Yup.object({
 name: Yup.string().required("Theme name is required"),
 primaryColor: Yup.string().required("Primary color is required"),
 secondaryColor: Yup.string().required("Secondary color is required"),
 fontFamily: Yup.string().required("Font family is required"),
 fontSize: Yup.string().required("Font size is required"),
 fontStyle: Yup.string().required("Font style is required"),
});

const dispatchSchema = Yup.object({
 trackingId: Yup.string().required("Tracking Id is required"),
 trackingUrl: Yup.string().required("Tracking Url is required"),
});

const MenuSchema = Yup.object().shape({
 label: Yup.string().required("Title is required"),
 type: Yup.string().required("Type is required"),
 url: Yup.string(),
 isMega: Yup.boolean(),
 categoryId: Yup.string().nullable(),
 parentId: Yup.string().nullable(),
 order: Yup.number()
  .required("Position is required")
  .min(0, "Position cannot be negative"),
});

const uploadSchema = Yup.object().shape({
 type: Yup.string().required("Type is required"),
 image: Yup.mixed()
  .required("Image is required")
  .test("fileSize", "File size is too large", (value) => {
   return value && value.size <= 7 * 1024 * 1024;
  })
  .test("fileFormat", "Unsupported Format", (value) => {
   return (
    value &&
    ["image/jpeg", "image/png", "image/jpg", "image/webp"].includes(value.type)
   );
  }),
});

const ShippingPartnerSchema = Yup.object({
 name: Yup.string().required("Name is required"),
});

const menuImageSchema = Yup.object({
 menu_id: Yup.string().required("Menu Id is required"),
 position: Yup.number().min(0, "Negative percentage is not allowde"),
 image: Yup.string().required("Image is required"),
});

const CollectionSchema = Yup.object({
 name: Yup.string().required("Name is required"),
 url: Yup.string().nullable(),
 image: Yup.mixed().required("Image image is required"),
});

const HomeSectionSchema = Yup.object().shape({
 position: Yup.number()
  .required("Position is required")
  .min(1, "Position must be at least 1"),
 title: Yup.string().required("Name is required"),
 bgcolor: Yup.string().required("Background color is required"),
 type: Yup.string()
  .oneOf(["COLLECTION", "PRODUCTS", "CMS", "CATALOGUE"])
  .required("Menu Type is required"),
 isActive: Yup.boolean(),
});

const PopupSchema = Yup.object().shape({
 heading: Yup.string().required("Heading is required"),
 headingStyle: Yup.string().required("Heading style is required"),
 type: Yup.string().required("Type is required"),
 link: Yup.string().required("Link is required"),
 description: Yup.string().required("Description is required"),
 image: Yup.mixed().required("Image is required"),
 modalPosition: Yup.string().required("Modal position is required"),
});

const TestimonialSchema = Yup.object({
  review_date: Yup.string().required("Date is required"),
  customer_name: Yup.string().trim().required("Customer name is required"),
  rating: Yup.number()
    .typeError("Rating must be a number")
    .min(1, "Minimum rating is 1")
    .max(5, "Maximum rating is 5")
    .required("Rating is required"),
  review: Yup.string().trim().required("Review is required"),
  image: Yup.string().nullable(),
  isActive: Yup.boolean(),
});


const paymentSchema = Yup.object({
  name: Yup.string()
    .trim()
    .required("Name is required"),
  isActive: Yup.boolean(),
});

const pageSchema = Yup.object({
  page: Yup.string().required("Page name is required"),
  action: Yup.string().required("Action is required"),
});
export {
 MenuSchema,
 SubMenuCollectionSchema,
 ProductSchema,
 CatlogProductSchema,
 catlogschema,
 StitchingOptionSchema,
 CollectionSchema,
 OrderSchema,
 brandSchema,
 currencyschema,
 shippingRateSchema,
 CatlogProductSchemaApply,
 Permissionschema,
 HandlerSchema,
 layoutSchema,
 shippingZoneSchema,
 CmsContentsSchema,
 ImportCurrencySchema,
 CatalogueproductValidationSchema,
 themeSchema,
 dispatchSchema,
 uploadSchema,
 ShippingPartnerSchema,
 menuImageSchema,
 HomeSectionSchema,
 PopupSchema,
 TestimonialSchema,
 paymentSchema,
 pageSchema
};
